import { render, staticRenderFns } from "./trading_home.vue?vue&type=template&id=1df304e5&scoped=true"
import script from "./trading_home.vue?vue&type=script&lang=js"
export * from "./trading_home.vue?vue&type=script&lang=js"
import style0 from "./trading_home.vue?vue&type=style&index=0&id=1df304e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df304e5",
  null
  
)

export default component.exports